import React from "react";
import ReactDOM from "react-dom";
import "sanitize.css/sanitize.css";
import * as serviceWorker from "./serviceWorker";
import App from "./containers/App";
import "./styles/layout/base.scss";
import { aplicarEscalaLayout } from "./utils/escalaLayout";

aplicarEscalaLayout();
ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
